import IngredientCategory from './setting/ingredient-category'
import IngredientUnit from './setting/ingredient-unit'
import ServiceCategory from './setting/service-category'
import DrugCondition from './setting/drug-condition'
import DrugPrice from './setting/drug-price'
import DrugCategory from './setting/drug-category'
import ProductCategory from './setting/product-category'
import ProductType from './setting/product-type'
import ProductUnit from './setting/product-unit'

export default {
  path: '/setting',
  component: () => import('@/views/settingSystem/setting-router.vue'),
  children: [
    IngredientCategory,
    IngredientUnit,
    ServiceCategory,
    DrugPrice,
    DrugCondition,
    DrugCategory,
    ProductCategory,
    ProductType,
    ProductUnit,
    {
      path: '',
      name: 'Setting',
      component: () => import('@/views/settingSystem/pages/SettingSystem.vue'),
      meta: {
        name: 'navigationDrawer.setting',
        icon: '/icons/setting.svg',
        auth: true
      }
    },
    // Router จัดการหมวดหมู่ประเภท
    {
      path: 'patient-type',
      name: 'PatientType',
      component: () => import('@/views/settingSystem/pages/ManagePatients/PatientType/PatientType.vue'),
      meta: {
        name: 'navigationDrawer.setting',
        icon: '/icons/setting.svg',
        auth: true
      }
    },
    {
      path: 'patient-type-create',
      name: 'PatientTypeCreate',
      component: () => import('@/views/settingSystem/pages/ManagePatients/PatientType/PatientTypeCreate.vue'),
      meta: {
        name: 'navigationDrawer.setting',
        icon: '/icons/setting.svg',
        auth: true
      }
    },
    {
      path: 'patient-type-edit/:id',
      name: 'PatientTypeEdit',
      component: () => import('@/views/settingSystem/pages/ManagePatients/PatientType/PatientTypeEdit.vue'),
      meta: {
        name: 'navigationDrawer.setting',
        icon: '/icons/setting.svg',
        auth: true
      }
    },
    // Router จัดการหมวดหมู่สิทธิการรักษา
    {
      path: 'patient-treatment',
      name: 'PatientTreatment',
      component: () => import('@/views/settingSystem/pages/ManagePatients/PatientTreatment/PatientTreatment.vue'),
      meta: {
        name: 'navigationDrawer.setting',
        icon: '/icons/setting.svg',
        auth: true
      }
    },
    {
      path: 'patient-treatment-create',
      name: 'PatientTreatmentCreate',
      component: () => import('@/views/settingSystem/pages/ManagePatients/PatientTreatment/PatientTreatmentCreate.vue'),
      meta: {
        name: 'navigationDrawer.setting',
        icon: '/icons/setting.svg',
        auth: true
      }
    },
    {
      path: 'patient-treatment-edit/:id',
      name: 'PatientTreatmentEdit',
      component: () => import('@/views/settingSystem/pages/ManagePatients/PatientTreatment/PatientTreatmentEdit.vue'),
      meta: {
        name: 'navigationDrawer.setting',
        icon: '/icons/setting.svg',
        auth: true
      }
    },
    // Router จัดการหมวดหมู่แท็ก
    {
      path: 'patient-tag',
      name: 'PatientTag',
      component: () => import('@/views/settingSystem/pages/ManagePatients/PatientTag/PatientTag.vue'),
      meta: {
        name: 'navigationDrawer.setting',
        icon: '/icons/setting.svg',
        auth: true
      }
    },
    {
      path: 'patient-tag-edit/:id',
      name: 'PatientTagEdit',
      component: () => import('@/views/settingSystem/pages/ManagePatients/PatientTag/PatientTagEdit.vue'),
      meta: {
        name: 'navigationDrawer.setting',
        icon: '/icons/setting.svg',
        auth: true
      }
    },
    {
      path: 'patient-tag-create',
      name: 'PatientTagCreate',
      component: () => import('@/views/settingSystem/pages/ManagePatients/PatientTag/PatientTagCreate.vue'),
      meta: {
        name: 'navigationDrawer.setting',
        icon: '/icons/setting.svg',
        auth: true
      }
    },
    // Router จัดการแพทย์
    {
      path: 'manage-doctor',
      name: 'ManageDoctor',
      component: () => import('@/views/settingSystem/pages/ManageDoctor/ManageDoctor.vue'),
      meta: {
        name: 'navigationDrawer.setting',
        icon: '/icons/setting.svg',
        auth: true
      }
    },
    {
      path: 'manage-doctor-create',
      name: 'ManageDoctorCreate',
      component: () => import('@/views/settingSystem/pages/ManageDoctor/ManageDoctorCreate.vue'),
      meta: {
        name: 'navigationDrawer.setting',
        icon: '/icons/setting.svg',
        auth: true
      }
    },
    {
      path: 'manage-doctor-edit/:id',
      name: 'ManageDoctorEdit',
      component: () => import('@/views/settingSystem/pages/ManageDoctor/ManageDoctorEdit.vue'),
      meta: {
        name: 'navigationDrawer.setting',
        icon: '/icons/setting.svg',
        auth: true
      }
    },
    // Router จัดการส่วนผสม
    // {
    //   path: 'ingredient-unit',
    //   name: 'IngredientUnit',
    //   component: () => import('@/views/settingSystem/pages/ingredient-unit/IngredientUnit.vue'),
    //   meta: {
    //     name: 'navigationDrawer.setting',
    //     icon: '/icons/setting.svg',
    //     auth: true
    //   }
    // },
    // Router จัดการหมวดหมู่สูตรยา
    {
      path: 'prescriptions-categories',
      name: 'PrescriptionsCategories',
      component: () => import('@/views/settingSystem/pages/ManagePrescriptions/PrescriptionsCategories.vue'),
      meta: {
        name: 'navigationDrawer.setting',
        icon: '/icons/setting.svg',
        auth: true
      }
    },
    {
      path: 'pill-conditions',
      name: 'PillConditions',
      component: () => import('@/views/settingSystem/pages/ManagePrescriptions/PillConditions.vue'),
      meta: {
        name: 'navigationDrawer.setting',
        icon: '/icons/setting.svg',
        auth: true
      }
    },
    // Router จัดการสินค้า
    {
      path: 'product-categories',
      name: 'ProductCategories',
      component: () => import('@/views/settingSystem/pages/product-category/ProductCategoryList.vue'),
      meta: {
        name: 'navigationDrawer.setting',
        icon: '/icons/setting.svg',
        auth: true
      }
    },
    {
      path: 'product-type',
      name: 'ProductType',
      component: () => import('@/views/settingSystem/pages/product-type/ProductTypeList.vue'),
      meta: {
        name: 'navigationDrawer.setting',
        icon: '/icons/setting.svg',
        auth: true
      }
    },
    {
      path: 'product-unit-setting',
      name: 'ProductUnitSetting',
      component: () => import('@/views/settingSystem/pages/product-unit/ProductUnitList.vue'),
      meta: {
        name: 'navigationDrawer.setting',
        icon: '/icons/setting.svg',
        auth: true
      }
    },
    // Router จัดการคอร์ส
    {
      path: 'course-categories',
      name: 'CourseCategories',
      component: () => import('@/views/settingSystem/pages/ManageCourse/CourseCategories.vue'),
      meta: {
        name: 'navigationDrawer.setting',
        icon: '/icons/setting.svg',
        auth: true
      }
    },
    {
      path: 'course-categories-create',
      name: 'CourseCategoriesCreate',
      component: () => import('@/views/settingSystem/pages/ManageCourse/CourseCategoriesCreate.vue'),
      meta: {
        name: 'navigationDrawer.setting',
        icon: '/icons/setting.svg',
        auth: true
      }
    },
    {
      path: 'course-categories-edit/:id',
      name: 'CourseCategoriesEdit',
      component: () => import('@/views/settingSystem/pages/ManageCourse/CourseCategoriesEdit.vue'),
      meta: {
        name: 'navigationDrawer.setting',
        icon: '/icons/setting.svg',
        auth: true
      }
    },
    // Router จัดการคลินิก
    {
      path: 'clinic-room',
      name: 'ClinicRoom',
      component: () => import('@/views/settingSystem/pages/ManageClinic/ClinicRoom.vue'),
      meta: {
        name: 'navigationDrawer.setting',
        icon: '/icons/setting.svg',
        auth: true
      }
    },
    {
      path: 'clinic-room-genaral',
      name: 'ClinicRoomGenaral',
      component: () => import('@/views/settingSystem/pages/ManageClinic/ClinicRoomGenaral.vue'),
      meta: {
        name: 'navigationDrawer.setting',
        icon: '/icons/setting.svg',
        auth: true
      }
    },
    {
      path: 'clinic-room-create',
      name: 'ClinicRoomCreate',
      component: () => import('@/views/settingSystem/pages/ManageClinic/ClinicRoomCreate.vue'),
      meta: {
        name: 'navigationDrawer.setting',
        icon: '/icons/setting.svg',
        auth: true
      }
    },
    {
      path: 'clinic-room-detail/:id',
      name: 'ClinicRoomDetail',
      component: () => import('@/views/settingSystem/pages/ManageClinic/ClinicRoomDetail.vue'),
      meta: {
        name: 'navigationDrawer.setting',
        icon: '/icons/setting.svg',
        auth: true
      }
    },
    {
      path: 'clinic-room-edit/:id',
      name: 'ClinicRoomEdit',
      component: () => import('@/views/settingSystem/pages/ManageClinic/ClinicRoomEdit.vue'),
      meta: {
        name: 'navigationDrawer.setting',
        icon: '/icons/setting.svg',
        auth: true
      }
    },
    // Router จัดการตั้งค่า
    {
      path: 'form-list',
      name: 'FormList',
      component: () => import('@/views/settingSystem/pages/ManageSetting/formList/FormList.vue'),
      meta: {
        name: 'navigationDrawer.setting',
        icon: '/icons/setting.svg',
        auth: true
      }
    },
    {
      path: 'medical-certificate',
      name: 'MedicalCertificate',
      component: () => import('@/views/settingSystem/pages/ManageSetting/formList/MedicalCertificate.vue'),
      meta: {
        name: 'navigationDrawer.setting',
        icon: '/icons/setting.svg',
        auth: true
      }
    },
    {
      path: 'treatment-certificate',
      name: 'TreatmentCertificate',
      component: () => import('@/views/settingSystem/pages/ManageSetting/formList/TreatmentCertificate.vue'),
      meta: {
        name: 'navigationDrawer.setting',
        icon: '/icons/setting.svg',
        auth: true
      }
    },
    {
      path: 'medical-certificate-small',
      name: 'MedicalCertificateSmalls',
      component: () => import('@/views/settingSystem/pages/ManageSetting/formList/MedicalCertificateSmall.vue'),
      meta: {
        name: 'navigationDrawer.setting',
        icon: '/icons/setting.svg',
        auth: true
      }
    },
    // Router ข่าวสาร
    {
      path: 'news',
      name: 'News',
      component: () => import('@/views/settingSystem/pages/ManageSetting/news/News.vue'),
      meta: {
        name: 'navigationDrawer.setting',
        icon: '/icons/setting.svg',
        auth: true
      }
    },
    {
      path: 'news-create',
      name: 'NewsCreate',
      component: () => import('@/views/settingSystem/pages/ManageSetting/news/NewsCreate.vue'),
      meta: {
        name: 'navigationDrawer.setting',
        icon: '/icons/setting.svg',
        auth: true
      }
    },
    {
      path: 'news-edit/:id',
      name: 'NewsEdit',
      component: () => import('@/views/settingSystem/pages/ManageSetting/news/NewsEdit.vue'),
      meta: {
        name: 'navigationDrawer.setting',
        icon: '/icons/setting.svg',
        auth: true
      }
    },
    {
      path: 'news-detail/:id',
      name: 'NewsDetail',
      component: () => import('@/views/settingSystem/pages/ManageSetting/news/NewsDetail.vue'),
      meta: {
        name: 'navigationDrawer.setting',
        icon: '/icons/setting.svg',
        auth: true
      }
    },
    // Router ข่าวสาร
    {
      path: 'language',
      name: 'Language',
      component: () => import('@/views/settingSystem/pages/ManageSetting/language/Language.vue'),
      meta: {
        name: 'navigationDrawer.setting',
        icon: '/icons/setting.svg',
        auth: true
      }
    },
    // Router ข้อมูลคลินิก
    {
      path: 'clinic-data/:id',
      name: 'ClinicData',
      component: () => import('@/views/settingSystem/pages/ManageSetting/clinicData/ClinicData.vue'),
      meta: {
        name: 'navigationDrawer.setting',
        icon: '/icons/setting.svg',
        auth: true
      }
    },
    {
      path: 'clinic-create/:id',
      name: 'ClinicCreate',
      component: () => import('@/views/settingSystem/pages/ManageSetting/clinicData/ClinicCreate.vue'),
      meta: {
        name: 'navigationDrawer.setting',
        icon: '/icons/setting.svg',
        auth: true
      }
    },
    // Router ข้อมูลผู้ใช้งาน
    {
      path: 'user',
      name: 'User',
      component: () => import('@/views/settingSystem/pages/ManageSetting/user/User.vue'),
      meta: {
        name: 'navigationDrawer.setting',
        icon: '/icons/setting.svg',
        auth: true
      }
    },
    {
      path: 'user-create',
      name: 'UserCreate',
      component: () => import('@/views/settingSystem/pages/ManageSetting/user/UserCreate.vue'),
      meta: {
        name: 'navigationDrawer.setting',
        icon: '/icons/setting.svg',
        auth: true
      }
    },
    {
      path: 'user-edit/:id',
      name: 'UserEdit',
      component: () => import('@/views/settingSystem/pages/ManageSetting/user/UserEdit.vue'),
      meta: {
        name: 'navigationDrawer.setting',
        icon: '/icons/setting.svg',
        auth: true
      }
    },
    // Router ธีมสี
    {
      path: 'theme',
      name: 'Theme',
      component: () => import('@/views/settingSystem/pages/ManageSetting/theme/Theme.vue'),
      meta: {
        name: 'navigationDrawer.setting',
        icon: '/icons/setting.svg',
        auth: true
      }
    },
    // Router ดาวโหลด
    {
      path: 'download',
      name: 'Download',
      component: () => import('@/views/settingSystem/pages/ManageSetting/downloads/Download.vue'),
      meta: {
        name: 'navigationDrawer.setting',
        icon: '/icons/setting.svg',
        auth: true
      }
    },
    // Router คำนำหน้า
    {
      path: 'prefix',
      name: 'Prefix',
      component: () => import('@/views/settingSystem/pages/ManageSetting/prefix/Prefix.vue'),
      meta: {
        name: 'navigationDrawer.setting',
        icon: '/icons/setting.svg',
        auth: true
      }
    },
    {
      path: 'prefix-create',
      name: 'PrefixCreate',
      component: () => import('@/views/settingSystem/pages/ManageSetting/prefix/PrefixCreate.vue'),
      meta: {
        name: 'navigationDrawer.setting',
        icon: '/icons/setting.svg',
        auth: true
      }
    },
    {
      path: 'prefix-edit/:id',
      name: 'PrefixEdit',
      component: () => import('@/views/settingSystem/pages/ManageSetting/prefix/PrefixEdit.vue'),
      meta: {
        name: 'navigationDrawer.setting',
        icon: '/icons/setting.svg',
        auth: true
      }
    },
    // Router เพศ
    {
      path: 'gender',
      name: 'Gender',
      component: () => import('@/views/settingSystem/pages/ManageSetting/gender/Gender.vue'),
      meta: {
        name: 'navigationDrawer.setting',
        icon: '/icons/setting.svg',
        auth: true
      }
    },
    {
      path: 'gender-create',
      name: 'GenderCreate',
      component: () => import('@/views/settingSystem/pages/ManageSetting/gender/GenderCreate.vue'),
      meta: {
        name: 'navigationDrawer.setting',
        icon: '/icons/setting.svg',
        auth: true
      }
    },
    {
      path: 'gender-edit/:id',
      name: 'GenderEdit',
      component: () => import('@/views/settingSystem/pages/ManageSetting/gender/GenderEdit.vue'),
      meta: {
        name: 'navigationDrawer.setting',
        icon: '/icons/setting.svg',
        auth: true
      }
    },
    // Router กรุ๊ปเลือด
    {
      path: 'blood-type',
      name: 'BloodType',
      component: () => import('@/views/settingSystem/pages/ManageSetting/bloodType/BloodType.vue'),
      meta: {
        name: 'navigationDrawer.setting',
        icon: '/icons/setting.svg',
        auth: true
      }
    },
    {
      path: 'blood-type-create',
      name: 'BloodTypeCreate',
      component: () => import('@/views/settingSystem/pages/ManageSetting/bloodType/BloodTypeCreate.vue'),
      meta: {
        name: 'navigationDrawer.setting',
        icon: '/icons/setting.svg',
        auth: true
      }
    },
    {
      path: 'blood-type-edit/:id',
      name: 'BloodTypeEdit',
      component: () => import('@/views/settingSystem/pages/ManageSetting/bloodType/BloodTypeEdit.vue'),
      meta: {
        name: 'navigationDrawer.setting',
        icon: '/icons/setting.svg',
        auth: true
      }
    },
    // Router ช่องทางรู้จักคลินิค
    {
      path: 'contact-clinic',
      name: 'ContactClinic',
      component: () => import('@/views/settingSystem/pages/ManageSetting/contactClinic/ContactClinic.vue'),
      meta: {
        name: 'navigationDrawer.setting',
        icon: '/icons/setting.svg',
        auth: true
      }
    },
    {
      path: 'contact-clinic-create',
      name: 'ContactClinicCreate',
      component: () => import('@/views/settingSystem/pages/ManageSetting/contactClinic/ContactClinicCreate.vue'),
      meta: {
        name: 'navigationDrawer.setting',
        icon: '/icons/setting.svg',
        auth: true
      }
    },
    {
      path: 'contact-clinic-edit/:id',
      name: 'ContactClinicEdit',
      component: () => import('@/views/settingSystem/pages/ManageSetting/contactClinic/ContactClinicEdit.vue'),
      meta: {
        name: 'navigationDrawer.setting',
        icon: '/icons/setting.svg',
        auth: true
      }
    }
  ]
}
